import React, { ReactNode } from 'react';
import websitelogo from '../../assets/img/offerx-logo.svg';
import { Link } from 'react-router-dom';
import { routes } from '../routes/routes-names';
import regImg from '../../assets/img/w3.svg';

type Props = {
    children: ReactNode[] | ReactNode;
};

const MediaLayout: React.FC<Props> = ({ children }) => {
    return (
        <div className="lt-bg-gray-10 vh-100 overflow-auto">
            <header className="landing-page">
                <nav className="navbar navbar-expand-lg navbar-toggleable-sm navbar-light py-0">
                    <div className="container">
                        <Link to={routes.main} className="navbar-brand py-0 fs-28 fw-700">
                            <img loading='lazy'src={websitelogo} className="site-logo" alt="OfferX Logo"></img>
                        </Link>
                        <button
                            className="navbar-toggler border-0"
                            type="button"
                            data-bs-target="#offcanvasNavbar"
                            data-bs-toggle="offcanvas"
                            aria-label="Toggle navigation"
                        >
                            <span className="navbar-toggler-icon" />
                        </button>
                        <div
                            // aria-hidden="true"
                            // aria-labelledby="offcanvasNavbarLabel"
                            className="flex-sm-row-reverse offcanvas offcanvas-end"
                            id="offcanvasNavbar"
                            data-bs-scroll="true"
                            tabIndex={0}
                        >
                            <div className="offcanvas-header ml-auto">
                                <button
                                    data-sider-close
                                    aria-label="Close"
                                    className="btn-close text-reset ms-auto"
                                    data-bs-dismiss="offcanvas"
                                    type="button"
                                />
                            </div>
                            <div className="offcanvas-body mobile-offcanvas">
                                <ul className="navbar-nav flex-grow">
                                    <li className="nav-item">
                                        {/* <NavLink
                                            exact
                                            to={routes.contact}
                                            activeClassName="active"
                                            className="nav-link text-dark lt-text-footer text-decoration-underline"
                                            tabIndex={0}
                                            title="Contact Us"
                                        >
                                            <div className="d-flex align-items-center">
                                                <div>
                                                    <i className="bi bi-headset fs-20"></i>
                                                </div>
                                                <div>Contact Us</div>
                                            </div>
                                        </NavLink> */}
                                        <a
                                            target="_blank"
                                            href={routes.contact}
                                            className="nav-link lt-text-footer text-decoration-underline"
                                            tabIndex={0}
                                            title="Contact Us"
                                        >
                                            <div className="d-flex align-items-center">
                                                <div>
                                                    <i className="bi bi-headset fs-20"></i>
                                                </div>
                                                <div>Contact Us</div>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </nav>
            </header>
            <div className="container pb-0">
                <div className="row align-items-center justify-content-center my-3">
                    <div className="col-lg-7 col-md-6 mobile-hide">
                        <div className="reg-img">
                            <img loading='lazy'src={regImg} className="" alt="Registration Image" />
                        </div>
                    </div>
                    <div className="col-lg-5 col-md-12">
                        {/* <div className="margin-1366 media-layout-responsive">{children}</div> */}
                        <div className="">{children}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MediaLayout;
